export default "/assets/images/technology-graph-04.svg?7e69e79fa4f9d3780612eb30cc7548c5";